import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/missions/mission.html";
import MissionService from "Sources/services/mission-service";

import "Styles/components/mission.scss";

class Mission
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.mission = options.mission;
    this.onFavorite = options.onFavoriteClicked;
    this.onAddToSession = options.onAddToSessionClicked;
    this.onDelete = options.onDeleteClicked;
    this.onCopy = options.onCopyClicked;
    this.deleteable = options.deleteable;
    this.copyable = options.copyable;
    this.missionList = options.missionList;
    this.labelString= "";
    this.mission.selected = options.selected;
    this.showCheckbox = options.showCheckbox;
  }

  get mission()
  {
    return this._mission;
  }

  set mission(mission)
  {
    this._mission = mission;
    this.updateMission();
  }

  static setUpMission(options)
  {
    let instance = new Mission(options);
    instance.getLabels();
    instance.render();
    instance.setUpEventListeners();

    if(instance.showCheckbox)
    {
      instance.setCheckbox(instance.mission.selected);
    }

    return instance;
  }

  setUpEventListeners()
  {
    const FAVORITE_BTN_ID = ".favorite-mission-btn";
    const ADDTOSESSION_BTN_ID = ".add-to-session-btn";
    const COPY_BTN_ID = ".copy-mission-btn";
    const DELETE_BTN_ID = ".delete-mission-btn";
    const CHECKBOX = ".mission-checkbox__checkbox";

    let that = this;
    this.$element.find(FAVORITE_BTN_ID).on("click", function(e)
    {
      that.favoriteMission();
    });

    this.$element.find(ADDTOSESSION_BTN_ID).on("click", function(e)
    {
      that.addToSession();
    });

    this.$element.find(CHECKBOX).on("change", function(e)
    {
      that.onCheckboxChanged(this.checked);
    });

    this.$element.find(COPY_BTN_ID).on("click", function(e)
    {
      that.onCopy(that.mission);
    });

    this.$element.find(DELETE_BTN_ID).on("click", function(e)
    {
      that.onDelete(that.mission);
    });
  }

  getLabels()
  {
    this.mission.labels.forEach((label) => {
      this.labelString += (label + ", ");
    });
  }

  onCheckboxChanged(checked)
  {
    this.mission.selected = checked;
    this.addToSession();
  }

  setCheckbox(checkboxState)
  {
    let $checkbox = this.$element.find(".mission-checkbox__checkbox");
    $checkbox.prop("checked", checkboxState);
  }

  addToSession()
  {
    //this.mission.selected = !this.mission.selected;
    if(utils.isNotNull(this.missionList))
    {
      this.missionList.onAddToSessionClicked(this.mission);
    }
    else
    {
      this.onAddToSession(this.mission.key);
    }
    this.updateMission();
  }

  removeFromSession()
  {

  }

  favoriteMission()
  {
    let that = this;
    if(this.mission.favorite)
    {
      MissionService.unfavoriteMission(this.mission.key)
        .then((data) =>
        {
          this.onFavorite(this.mission);
        })
        .catch((err) =>
        {
          // TODO handle errors
        });
    }
    else
    {
      MissionService.favoriteMission(this.mission.key)
        .then((data) =>
        {
          this.onFavorite(this.mission);
        })
        .catch((err) =>
        {
          // TODO handle errors
        });
    }
  }

  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.prepend(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.updateMission();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  updateMission() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $missionName = this.$element.find("[data-bind-target='mission-name']");
      $missionName.empty();

      if (utils.isNotNull(this.mission) && utils.isNotNull(this.mission.name) && utils.isNotNull(this.mission.key)) {
        $missionName.text(this.mission.name);
        $missionName.attr("href", "/mission-detail/" + this.mission.key)
      }

      let $missionDate = this.$element.find("[data-bind-target='mission-date']");
      $missionDate.empty();

      if (utils.isNotNull(this.mission) && utils.isNotNull(this.mission.created)) {
        $missionDate.text(this.mission.created);
      }

      let $missionLabels = this.$element.find("[data-bind-target='mission-labels']");
      $missionLabels.empty();

      if (utils.isNotNull(this.mission) && utils.isNotNull(this.labelString)) {
        $missionLabels.text(this.labelString);
      }

      let $missionAuthor = this.$element.find("[data-bind-target='mission-author']");
      $missionAuthor.empty();

      if (utils.isNotNull(this.mission) && utils.isNotNull(this.mission.userName)) {
        $missionAuthor.text(this.mission.userName);
      }

      let $favoriteIcon = this.$element.find(".icn_favourite");
      if (utils.isNotNull(this.mission) && utils.isNotNull(this.mission.favorite)) {
        if(this.mission.favorite === true)
        {
          $favoriteIcon.removeClass("empty");
          $favoriteIcon.addClass("filled");
        }
        else
        {
          $favoriteIcon.removeClass("filled");
          $favoriteIcon.addClass("empty");
        }
      }

      let $deleteIcon = this.$element.find(".delete-mission-btn");
      if(this.deleteable)
        {
          $deleteIcon.show();
        }
        else
        {
          $deleteIcon.hide();
        }

      let $copyIcon = this.$element.find(".copy-mission-btn");
      if(this.copyable)
      {
        $copyIcon.show();
      }
      else
      {
        $copyIcon.hide();
      }

      this.showIcon();

      let $checkbox = this.$element.find(".custom-checkbox");
      let $addIcon = this.$element.find(".icn_add");

      if(this.showCheckbox)
      {
        $checkbox.show();
        $addIcon.hide();
      }
      else
      {
        $checkbox.hide();
        $addIcon.show();
      }
    }


  }

  showIcon()
  {
    switch(this.mission.source)
    {
      case "standard_mission":
        this.$element.find(".icn_mission_cartamundi").show();
        break;

      case "school_shared":
        this.$element.find(".icn_school").show();
        break;

      case "user_shared":
        this.$element.find(".icn_user").show();
        break;

      case "owner":
        this.$element.find(".icn_user").show();
        break;

      case null:
        this.$element.find(".icn_mission_cartamundi").show();
        break;

      default:
        this.$element.find(".icn_user").show();
        break;
    }
  }

}

export default Mission;



// WEBPACK FOOTER //
// ./app/js/components/mission.js